/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Buffer } from 'buffer';

import React, { SyntheticEvent, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { useTranslation } from '../../hooks/useTranslation';
import { trimImageMargins } from '../../../utils/trimImageMargins';

interface UploadFileProps {
  file: string;
  buttonText?: string;
  imageHeight?: number;
  setFile: (file: string) => void;
  setName?: (name: string) => void;
  requiredTransparent?: boolean;
  // Cuts empty margins around the drawing (stamps, signatures) on upload.
  trimMargins?: boolean;
}

export const UploadImageFile: React.FC<UploadFileProps> = props => {
  const hiddenFileInput = useRef<HTMLInputElement>(null);
  const [trimmed, setTrimmed] = useState(false);
  const { t, tk } = useTranslation('commonLng');

  const handleClickImage = (event: SyntheticEvent) => {
    event.preventDefault();
    hiddenFileInput?.current?.click();
  };

  const setFile = (files: FileList | null) => {
    if (!files || files.length === 0) {
      return;
    }

    const f: File = files[0];
    const reader = new FileReader();
    reader.readAsArrayBuffer(f);
    reader.onload = function (e) {
      if (e.target) {
        const target: FileReader = e.target;
        if (target.result) {
          const file =
            'data:image/png;base64,' +
            Buffer.from(target.result as ArrayBuffer).toString('base64');
          if (props.trimMargins) {
            void trimImageMargins(file).then(trimmedFile => {
              setTrimmed(trimmedFile !== file);
              props.setFile(trimmedFile);
            });
          } else {
            props.setFile(file);
          }
          if (props.setName) {
            props.setName(f.name);
          }
        }
      }
    };
  };

  return (
    <>
      {props.file ? (
        props.requiredTransparent ? (
          <div className="transparent-image-wrapper">
            <div className="img-uploaded-container">
              <div className="checkerboard"></div>
              <img
                className="img-uploaded"
                src={props.file}
                alt="imageFile"
                height={props.imageHeight || 50}
                onClick={handleClickImage}
              />
            </div>
            <Form.Text className="mt-2">
              {t(tk.attachment.transparentBackgroundRequired)}
            </Form.Text>
          </div>
        ) : (
          <img
            src={props.file}
            alt="imageFile"
            height={props.imageHeight || 50}
            onClick={handleClickImage}
            style={{
              cursor: 'pointer',
              border: '1px solid #ccc',
            }}
          />
        )
      ) : (
        <Button variant="outline-secondary" onClick={handleClickImage}>
          {props.buttonText || 'Wgraj plik'}
        </Button>
      )}
      {props.file && trimmed && (
        <Form.Text className="d-block mt-2">
          {t(tk.attachment.imageMarginsTrimmed)}
        </Form.Text>
      )}
      <Form.Control
        type="file"
        accept="image/png"
        onChange={event =>
          setFile((event.currentTarget as HTMLInputElement).files)
        }
        style={{ display: 'none' }}
        ref={hiddenFileInput}
      />
    </>
  );
};
